import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { AFFILIATE_LINK, CTA_TEXT } from "@/config";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </M>
  );
};

export const Cta = ({ testId, variant = "mauve", label = CTA_TEXT, href = AFFILIATE_LINK }) => {
  const external = href.startsWith("http");
  const styles =
    variant === "light"
      ? "bg-[var(--blush)] text-[var(--ink)] hover:bg-white"
      : "bg-[var(--mauve)] text-white hover:bg-[var(--mauve-dark)]";
  return (
    <motion.a
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "sponsored noopener noreferrer" : undefined}
      data-testid={testId}
      whileTap={{ scale: 0.97 }}
      className={`group inline-flex min-h-[56px] items-center gap-3 rounded-full px-8 py-4 text-base font-semibold tracking-wide shadow-[0_10px_30px_-12px_rgba(161,45,104,0.45)] transition-colors duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--mauve)] ${styles}`}
    >
      {label}
      <span className="grid h-7 w-7 place-items-center rounded-full bg-white/20 transition-transform duration-300 group-hover:rotate-45">
        <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
      </span>
    </motion.a>
  );
};

export const Paras = ({ items, className = "", testId }) => (
  <div className={`space-y-5 ${className}`} data-testid={testId}>
    {items.map((p, i) => (
      <Reveal key={i} delay={Math.min(i * 0.05, 0.25)} as="p">
        {p}
      </Reveal>
    ))}
  </div>
);

export const Eyebrow = ({ children }) => (
  <p className="mb-5 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[var(--mauve)]">
    <span className="h-px w-8 bg-[var(--mauve)]" aria-hidden="true" />
    {children}
  </p>
);

export const Logo = () => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <span className="font-display text-lg italic text-[var(--ink)]">itsmeharleeey</span>
  </div>
);
